/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Dec 29 2023
 **/

import { useUsers } from "@/frameworks/core/API";
import { useQuery } from "@tanstack/react-query";

/**
 *
 * @param category "NORMAL"
 * @descrioption category "Chat" is not supported
 */
export default function useNotificationList(category: "NORMAL") {
	const userAPI = useUsers();
	const { refetch: fetchNextPage, data } = useQuery([`useNotificationLogs${category}`], {
		queryFn: async ({ pageParam = 1 }) => {
			const result = await userAPI.notificationLogs.inquiry.execute({
				category: category,
				page: pageParam,
				pageSize: 100
			});
			return {
				hasNextPage: result.data?.hasNext || false,
				nextPage: result.data?.content?.slice(-1)[0]?.id ?? null,
				data: result.data
			};
		},
		refetchOnWindowFocus: false,
		enabled: false,
		keepPreviousData: false,
		cacheTime: 0,
		staleTime: 0
	});

	return {
		fetchNextPage,
		data
	};
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getKeyByValue(object: any, targetValue: string) {
	return Object.entries(object).find(([, value]) => value === targetValue)?.[0];
}
